export default __webpack_public_path__ + "static/BPA West Malling-303474ed313283039a3ed62fd9b37e98.png";